import Link from 'next/link'

import starIcon from '@/shared/assets/star.svg'
import { getPostLink } from '@/shared/lib/post-link'

import styles from './view.module.css'

type PostTitleLinkProps = {
    showStar: boolean
    title: string
    label: string
    slug: string
}

export function PostTitleLink({ label, slug, title, showStar }: PostTitleLinkProps) {
    const href = getPostLink({ label, slug })

    return (
        <section className={styles.containerLink}>
            <h2 className={styles.titleHeading}>
                <Link href={href} prefetch={false} className={styles.titleLink}>
                    {showStar && (
                        <img
                            src={starIcon.src}
                            height={64}
                            width={64}
                            alt="star"
                            className={styles.star}
                            draggable="false"
                        />
                    )}
                    <span dangerouslySetInnerHTML={{ __html: title }} />
                </Link>
            </h2>
        </section>
    )
}

type PostTitleNew = {
    title: string
    showStar: boolean
}

export function PostTitle({ title, showStar }: PostTitleNew) {
    return (
        <section className={styles.container}>
            {showStar && <img src={starIcon.src} height={64} width={64} alt="star" draggable="false" />}
            <h1 className={styles.titleHeading} dangerouslySetInnerHTML={{ __html: title }} />
        </section>
    )
}
